import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { aspMngr } from '@core_n/asp/AspMngr';
import { ObjectType } from '@core_n/asp/AspObject';
import { mainMapMngr } from '@core_n/asp/MapMngr';
import { SensorCoreObject } from '@core_n/asp/SensorCoreObject';
import { SensorsCorePool } from '@core_n/asp/SensorsCorePool';
import { sensorsPool } from '@core_n/asp/aspObjects';
import { AppInjector } from '@core_n/common/inject';
import { ShowErrorsDialogComponent } from '@core_n/show-errors/show-errors.component';
import { AroSensorService } from 'src/app/aro/aro-sensor.service';
import { SensorObject } from 'src/app/asp/SensorObject';
import { settings } from 'cluster';
import { userSettings } from '@core_n/common/settings';


@Component({
  selector: 'app-alert-box',
  templateUrl: './alert-box.component.html',
  styleUrls: ['./alert-box.component.scss']
})

export class AlertBoxComponent implements OnInit {

  public sensor: SensorCoreObject;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,
    private snackBarRef: MatSnackBarRef<AlertBoxComponent>,
    protected dialog: MatDialog,
  ) {
    this.sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get((data.data.StreamName as string).toLowerCase());
    if (!this.sensor)
      this.sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get((data.data.StreamName as string).toLowerCase() + ".stream");
  }

  ngOnInit() {
  }

  getIcon() {
    switch (this.data.msgType) {
      case 'Success':
        return 'check_circle';
      case 'Error':
        return 'error';
      case 'Warn':
        return 'warning';
      case 'Info':
        return 'notifications';
    }
  }

  openAlertWindow() {
    // if (!this.dialog.getDialogById(ShowErrorsDialogComponent.DIALOG_ID))
    //   this.dialog.open(ShowErrorsDialogComponent, ShowErrorsDialogComponent.createDialogConfig(100));

    userSettings.TriggerAlertWindow.next(!userSettings.TriggerAlertWindow.value);
  }

  onBtnClick() {
    this.snackBarRef.dismiss();
  }
}
